import { render, staticRenderFns } from "./GithubRibbon.vue?vue&type=template&id=5e0e728e&scoped=true&"
import script from "./GithubRibbon.vue?vue&type=script&lang=js&"
export * from "./GithubRibbon.vue?vue&type=script&lang=js&"
import style0 from "./GithubRibbon.vue?vue&type=style&index=0&id=5e0e728e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0e728e",
  null
  
)

export default component.exports